/**
 * The brand catalog mount (Ari, 2026-10-20). Pure, so its claim proofs run in
 * api Jest (apps/api/src/catalog/catalog-brand-access.web.claims.spec.ts).
 *
 * Open only when all three hold:
 * - the global kill switch `VITE_CATALOG_BRAND_ENABLED` is on (passed in as `flagOn`);
 * - the viewer is a brand admin;
 * - the server says the viewer's brand has catalog access (`users.me`
 *   `brand.catalogAccess`: an onboarding record, or the GB admin switch).
 * GB admins use the catalog through `canOperateCatalog`, not this.
 */
export interface BrandCatalogViewer {
  role: string;
  brand: { catalogAccess?: boolean } | null;
}

export function brandCatalogOpen(flagOn: boolean, viewer: BrandCatalogViewer | null | undefined): boolean {
  if (!flagOn || !viewer) return false;
  return viewer.role === "BRAND_ADMIN" && viewer.brand?.catalogAccess === true;
}
